var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiConversationLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 6.66667C15.7339 6.66667 16.6667 5.73392 16.6667 4.58333C16.6667 3.43274 15.7339 2.5 14.5833 2.5C13.4327 2.5 12.5 3.43274 12.5 4.58333C12.5 5.73392 13.4327 6.66667 14.5833 6.66667Z",
    stroke: "#616B84",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41659 12.0834C6.56717 12.0834 7.49992 11.1506 7.49992 10C7.49992 8.84944 6.56717 7.91669 5.41659 7.91669C4.266 7.91669 3.33325 8.84944 3.33325 10C3.33325 11.1506 4.266 12.0834 5.41659 12.0834Z",
    stroke: "#616B84",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 5.65607L7.22461 8.85227",
    stroke: "#616B84",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22437 11.0683L12.7829 14.3529",
    stroke: "#616B84",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 13.3333C15.7339 13.3333 16.6667 14.2661 16.6667 15.4166C16.6667 16.5672 15.7339 17.5 14.5833 17.5C13.4327 17.5 12.5 16.5672 12.5 15.4166C12.5 14.2661 13.4327 13.3333 14.5833 13.3333Z",
    stroke: "#616B84",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiConversationLink);
export default __webpack_public_path__ + "static/media/hi-conversation-link.431da4df5c1eac0f5168ed389c9029a0.svg";
export { ForwardRef as ReactComponent };